export const PAID_PACKAGE_NAMES = ['Starter', 'Standard', 'Business', 'Premium'];

export const PACKAGE_PRICE_LABELS = {
  Starter: '19 € / mesec',
  Standard: '39 € / mesec',
  Business: '79 € / mesec',
  Premium: 'Po dogovoru'
};

export const PACKAGE_FEATURE_KEYS = {
  Starter: [
    'home.landing.pricing.starter.features.workers',
    'home.landing.pricing.starter.features.partners',
    'home.landing.pricing.starter.features.clients',
    'home.landing.pricing.starter.features.jobs',
    'home.landing.pricing.starter.features.crm',
    'home.landing.pricing.starter.features.dashboard',
    'home.landing.pricing.starter.features.archive',
    'home.landing.pricing.starter.features.analytics',
    'home.landing.pricing.starter.features.mobile'
  ],
  Standard: [
    'home.landing.pricing.standard.features.workers',
    'home.landing.pricing.standard.features.partners',
    'home.landing.pricing.standard.features.marketing',
    'home.landing.pricing.standard.features.ai',
    'home.landing.pricing.standard.features.jobs',
    'home.landing.pricing.standard.features.inventory',
    'home.landing.pricing.standard.features.warehouseParts',
    'home.landing.pricing.standard.features.reversiWithdrawn',
    'home.landing.pricing.standard.features.workOrderPersonalization',
    'home.landing.pricing.standard.features.vehicles',
    'home.landing.pricing.standard.features.analytics'
  ],
  Business: [
    'home.landing.pricing.business.features.allFromStarter',
    'home.landing.pricing.business.features.allFromStandard',
    'home.landing.pricing.business.features.workers',
    'home.landing.pricing.business.features.partners',
    'home.landing.pricing.business.features.marketing',
    'home.landing.pricing.business.features.inventory',
    'home.landing.pricing.business.features.webshop',
    'home.landing.pricing.business.features.analytics',
    'home.landing.pricing.business.features.logoPersonalization'
  ],
  Premium: [
    'home.landing.pricing.premium.features.allFromBusiness',
    'home.landing.pricing.premium.features.ai',
    'home.landing.pricing.premium.features.support',
    'home.landing.pricing.premium.features.databases',
    'home.landing.pricing.premium.features.websites',
    'home.landing.pricing.premium.features.manager',
    'home.landing.pricing.premium.features.api'
  ]
};

export const getPackageFeatureItems = (packageName, t) => {
  const keys = PACKAGE_FEATURE_KEYS[packageName] || [];
  return keys.map((key) => t(key));
};
